import { Component, Inject, inject, OnInit } from '@angular/core';
import { AmplifyUser } from '@aws-amplify/ui';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { ConfigService } from '../../../config.service';
import { MatDialog } from '@angular/material/dialog';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { GlobalDataService } from '../../../services/global-data.service';
import { detectEnv } from 'src/app/services/Enviroment';
import { TranslateService } from '@ngx-translate/core';
import {AuthService} from "../../../services/auth.service";
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';

@Component({
  selector: 'app-backoffice-users',
  templateUrl: './users.component.html',
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `,
  ],
})
export class BOUsersComponent implements OnInit {
  showSpinner = false;
  window = window;
  dialog = inject(MatDialog);
  lambda = inject(AWSLambda);
  rolesCheck = inject(BoRolesCheckService);
  protected currentEnv = detectEnv();
  user!: AmplifyUser;
  attributes: CognitoUserAttribute[] = [];
  canAccess = false;


  // Propiedades para manejar usuarios de Cognito
  userList: any[] = [];
  paginationToken: string | null = null;
  hasMoreUsers: boolean = true;
  loadingUsers: boolean = false;
  filteredCounts: { userList: number } = { userList: 0 };
  filterUsers: any[] = [];

  constructor(
    private router: Router,
    private translate: TranslateService,
    private auth: AuthService,
  ) {}

  // Cargar usuarios al inicializar el componente
  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    await this.auth.refresh()
    this.user = await Auth.currentAuthenticatedUser();
    this.getUserList();
  }

  // Método para obtener lista de usuarios desde Lambda (Cognito)
  async getUserList(): Promise<void> {
    if (this.loadingUsers || !this.hasMoreUsers) return;
    this.loadingUsers = true;

    try {
      let response;
      const params = this.paginationToken ? { paginationToken: this.paginationToken } : {};

      // Aquí aseguramos que el endpoint es el que consulta Cognito
      response = await this.lambda.getLambdaFunction('lambda', '/get/userslist', {
        queryStringParameters: params,
      });

      if (response && response.users && Array.isArray(response.users)) {
        this.userList = [...this.userList, ...response.users]
          .sort((a, b) => new Date(b.UserCreateDate).getTime() - new Date(a.UserCreateDate).getTime());

        this.paginationToken = response.paginationToken || null;
        this.hasMoreUsers = !!this.paginationToken;

        const uniqueUserStatuses = Array.from(
          new Set(response.users.map((user: { UserStatus: any; }) => user.UserStatus))
        ).map(status => ({
          key: status,
          value: status
        }));

        //   const portal: { key: string; value: string }[] = [
        //   { key: 'cliente', value: 'cliente' },
        //   { key: 'backoffice', value: 'backoffice' },
        //   { key: 'btb', value: 'btb' },
        // ];

        this.filterUsers = [
          { key: 'fullname', type: 'text', label:  this.translate.instant('COMPONENTS.TABS.BACK.Name') },
          { key: 'phone_number', type: 'text', label: this.translate.instant('COMPONENTS.TABS.BACK.Phone') },
          { key: 'email', type: 'text', label: this.translate.instant('COMPONENTS.TABS.BACK.Email') },
          // { key: 'portal', type: 'select', label: 'Portal', options: portal },
          { key: 'UserStatus', type: 'select', label: this.translate.instant('COMPONENTS.TABS.BACK.Status'), options: uniqueUserStatuses },
        ];
      } else {
        // Si no hay más usuarios o no es un array
        this.hasMoreUsers = false;
      }
    } catch (error) {
      console.error('Error al obtener usuarios de Cognito:', error);
    } finally {
      this.loadingUsers = false;
    }
  }

  // Método para cargar más usuarios (paginación)
  async loadMoreUsers(): Promise<void> {
    if (this.hasMoreUsers) {
      await this.getUserList();
    }
  }

  onNewUser(): void {
    this.router.navigate(['/backoffice/users/edit/new']);
  }

  onUserClick(user: any): void {
    this.router.navigate(['/backoffice/users', user.sub]);
  }
  
  onFiltersChanged(filters: any) {
    console.log('Filters updated:', filters);
  }

  // Método auxiliar opcional para simular retardo
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Refrescar la lista (si deseas un botón de "Refrescar")
  async refreshUserList(): Promise<void> {
    this.userList = [];
    this.paginationToken = null;
    this.hasMoreUsers = true;
    await this.getUserList();
  }
}
